import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as Sentry from '@sentry/react';

import client from 'utils/client';

import Nav from '../components/Nav';
import Loading from '../components/Loading';
import TotalContainer from '../components/TotalContainer';
import ProductGroups from '../components/review/ProductGroups';
import stepAnalytics from '../utils/stepAnalytics';
import addToCartAnalytics from '../utils/addToCartAnalytics';
import Help from '../components/help/Help';

class ReviewOrder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      totalContainerLink: '/revieworder/'
    };
    this.submitOrder = this.submitOrder.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    stepAnalytics('/summary', 'summary', 'step 4');
    if (!this.props.choices.length) {
      if (this.props.settings.groupID) {
        window.location.href = `/teamsport/#/colors/${this.props.settings.groupID}/`;
      } else {
        window.location.href = '/v/team-sport/';
      }
    }
    this.props.getReviewTranslations();
    this.props.updateAlert('none');
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  toggleHelpAlert = () => {
    this.props.toggleHelp();
  };

  UNSAFE_componentWillMount() {
    window.scrollTo(0, 0);
    window.addEventListener('scroll', this.handleScroll);
  }

  // Error on Analytics to see
  submitOrder() {
    client.post('/services/product_groups/set_order/').then(() => {
      try {
        addToCartAnalytics(this.props.review);
      } catch (error) {
        Sentry.captureException(error);
      }
      window.location.href = '/cart/summary/';
    });
  }

  handleScroll() {
    if (window.pageYOffset > 175) {
      this.setState({ totalContainerSticky: true });
    } else {
      this.setState({ totalContainerSticky: false });
    }
  }

  render() {
    return (
      <div>
        <Nav />
        {this.props.helpShown && (
          <Help
            toggleAlert={this.toggleHelpAlert}
            path={this.props.match.path}
          />
        )}

        {this.props.getReviewResponse &&
        (this.props.getReviewResponse === 'success' ||
          this.props.getReviewResponse === true) ? (
          <div className="teamsport_content">
            <div className="main_container">
              <div className="reviewOrder">
                <div className="titleContainer titleContent">
                  <span className="title titleText">
                    {this.props.generalTranslations.Review_Order}
                  </span>
                  <div
                    className="helpButton"
                    onClick={this.toggleHelpAlert}
                    role="button"
                    tabIndex="0"
                    style={{ outline: 'none' }}
                  >
                    {this.props.generalTranslations.NeedHelp}
                  </div>
                </div>
                <ProductGroups
                  orderPreviewGroups={this.props.review}
                  orderPreviewPrices={this.props.orderPreviewPrices}
                  currency={this.props.currency}
                />
              </div>
            </div>
            <TotalContainer
              totalContainerSticky={this.state.totalContainerSticky}
              totalContainerLink={this.state.totalContainerLink}
              totalContainerLinkText={this.props.reviewTranslations.AddToBasket}
              submitOrder={this.submitOrder}
              OrangeButton
            />
          </div>
        ) : (
          <Loading />
        )}
      </div>
    );
  }
}

const mapDispatch = dispatch => ({
  requestReview: () =>
    dispatch({
      type: 'REQUEST_REVIEW'
    }),
  getReviewTranslations: () =>
    dispatch({
      type: 'GET_REVIEW_TRANSLATIONS'
    }),
  updateAlert: alertElement =>
    dispatch({
      type: 'UPDATE',
      alertElement
    }),
  toggleHelp: () =>
    dispatch({
      type: 'TOGGLE_HELP'
    })
});

const mapState = state => ({
  choices: state.choices,
  review: state.review,
  getReviewResponse: state.getReviewResponse,
  total: state.total,
  settings: state.settings,
  reviewTranslations: state.reviewTranslations,
  generalTranslations: state.generalTranslations,
  helpShown: state.helpShown
});

export default withRouter(connect(mapState, mapDispatch)(ReviewOrder));
